import {List, ListItem} from "@mui/material";
import React from "react";
import {useAdmissionList, useAdmissionListOptions} from "~/apps/packages/passes/hooks";
import {AdmissionItem} from "./AdmissionItem";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export type AdmissionListProps = {
    type?: useAdmissionListOptions["type"]
    query?: string
    statuses?: number[]
}


export const AdmissionList = (props: AdmissionListProps) => {
    const {type, query, statuses} = props;
    const {data: passes, loading} = useAdmissionList({
        type: type,
        query: query,
        statuses: statuses
    });

    return (
        <LoadingBox isInitialLoading={passes == undefined} loading={loading} empty={passes?.length == 0}>
            {passes?.length > 0 && (
                <List>
                    {passes.map((item, index) => (
                        <ListItem key={index}>
                            <AdmissionItem admission={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    )
}